export const sevenDays = 7 * 24 * 60 * 60 * 1000;

export const freeFinancialAidLink = (isFinFitPartnership: boolean) =>
  isFinFitPartnership
    ? 'https://dollarfor.org/help/?aid=resolve&utm_source=finfit&utm_medium=resolve+partner&utm_campaign=funnel'
    : 'https://dollarfor.org/resolve';

export const ANON_ID_LOCAL_KEY = 'anon_id' as const;
